import { Injectable } from "@angular/core";
import { EnvironmentApiService } from "../core/services/environment-api.service";
import { Observable } from "rxjs";

@Injectable({
    providedIn: "root"
})
export class ContactUsService extends EnvironmentApiService {

    sendMessage(request: Message): Observable<{
        success: boolean,
        error: string
    }> {
        return this.httpClient.post<{
            success: boolean,
            error: string
        }>(
            `${this.baseApi}/ContactUs/AddContactUs`, request
        );
    }

}

export class Message {
    name: string = '';
    email: string = '';
    phone: string = '';
    message: string = '';
    dialCode:string = '';

}